<template>
  <form id="create_ticket_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">افزودن تیکت</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label>عنوان</label>
          <input
            type="text"
            name="title"
            v-model="form.title"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>اولویت</label>
          <div class="radio-inline">
            <label
              v-for="(type, key) in ticketPriority"
              :key="`type-${key}`"
              class="radio"
            >
              <input
                type="radio"
                name="type"
                :value="key"
                v-model="form.priority"
              />
              <span></span>
              {{ type }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <label>پیام</label>
          <textarea
            v-model="form.message"
            id="message"
            class="form-control"
          ></textarea>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  STORE_TICKET,
  STORE_TICKET_MESSAGE
} from "@/core/services/store/tickets.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";

export default {
  name: "tickets-create",
  props: ["id"],
  data() {
    return {
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      form: {
        title: "",
        priority: "",
        message: ""
      }
    };
  },
  mounted() {
    this.setBreadcrumbs();
    this.setActions();

    this.eventHub.$on("save-ticket-event", this.save);

    this.fv = formValidation(document.getElementById("create_ticket_form"), {
      fields: {
        title: {
          validators: {
            notEmpty: {
              message: "عنوان صحیح نیست"
            },
            stringLength: {
              min: 2,
              max: 128,
              message: "عنوان صحیح نیست"
            }
          }
        },
        message: {
          selector: "#message",
          validators: {
            notEmpty: {
              message: "پیام صحیح نیست"
            },
            stringLength: {
              min: 2,
              max: 128,
              message: "پیام صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off("save-ticket-event");
    document.getElementById("save-ticket-btn").disabled = false;
  },

  computed: {
    ...mapGetters(["currentUserProperty", "ticket", "ticketPriority"])
  },
  methods: {
    setBreadcrumbs() {
      let ticketsRouteName = "tickets-index";

      let items = [];

      items.push({ title: "پشتیبانی", route: { name: ticketsRouteName } });
      items.push({ title: "افزودن تیکت" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      let ticketsRouteName = "tickets-index";

      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "save-ticket-event",
            class: "btn-primary",
            id: "save-ticket-btn"
          }
        ],
        links: [
          {
            name: "بازگشت",
            to: { name: ticketsRouteName }
          }
        ]
      });
    },
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-ticket-btn");
          this.disableBtn(submitBtn);

          this.$store
            .dispatch(STORE_TICKET, {
              user:
                this.isCompany || this.isAdmin ? this.$route.params.id : null,
              title: this.form.title,
              priority: parseInt(this.form.priority)
            })
            .then(ticket => {
              this.$store
                .dispatch(STORE_TICKET_MESSAGE, {
                  id: ticket.id,
                  formData: {
                    content: this.form.message
                  }
                })
                .then(() => {
                  this.$router.push({
                    name: "tickets-show",
                    params: { id: ticket.id }
                  });
                })
                .catch(() => {
                  this.enableBtn(submitBtn);
                  this.$router.push({
                    name: "tickets-show",
                    params: { id: ticket.id }
                  });
                });
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    }
  }
};
</script>
